import React from 'react';

import {BaseProps} from "../../../../../../../infrastructure/models/props/base-props";
import {GameCenterHeaderModuleController} from "../../../game-center-header-module.controller";
import {GameCenterHeaderModuleDetailsStatusGame} from "./game-center-header-module.details.status-game";
import {GameAggregate} from "../../../../../../../core/components/game-aggregate/game.aggregate";
import styles from "../../../styles/game-center-header-status.module.scss";
import classNames from "classnames";
import {observer} from "mobx-react";
import {GameCenterHeaderModuleDetailsStatusScore} from "./game-center-header-module.details.status-score";
import {Text} from "../../../../../../../core/components/misc/text/text";

export class GameCenterHeaderModuleDetailsStatusProps extends BaseProps {
  controller: GameCenterHeaderModuleController;
}

export const GameCenterHeaderModuleDetailsStatus = observer(({controller}: GameCenterHeaderModuleDetailsStatusProps) => {
  const {state} = controller;
  const {isLive, bottomScoreText} = state;
  const {device: {isSmallView}} = state;

  const bottomScoreTextProps = {
    text: !isLive ? bottomScoreText : '',
    className: classNames(styles.button_score_text)
  };

  const aggregateProps = {
    className: classNames(styles.aggregate),
    game: state
  };

  return (
    <div className={classNames(styles.container, {[styles.small_view]: isSmallView})}>
      <GameCenterHeaderModuleDetailsStatusGame controller={controller}/>
      <GameCenterHeaderModuleDetailsStatusScore controller={controller}/>
      <Text {...bottomScoreTextProps}/>
      <GameAggregate {...aggregateProps}/>
    </div>
  )
});
